import React from "react";

const InvoiceIcon = ({ className }) => {
  return (
    <svg
      viewBox="0 0 27 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.0559 13.5H0.620117V15.1026C0.621336 16.0679 1.37471 16.8674 2.34473 16.933C2.36545 16.93 2.38635 16.9283 2.40725 16.9281H11.7919C11.3182 16.4185 11.0554 15.7504 11.0559 15.0568V13.5Z"
        fill="currentColor"
      />
      <path
        d="M3.54861 1.15753L3.4707 12.583H11.4959C11.7418 12.583 11.9411 12.7826 11.9411 13.0286V15.0418C11.9411 16.0118 12.7141 16.839 13.6629 16.9257H13.8147C13.839 16.9259 13.8634 16.928 13.8874 16.9322C14.9054 16.8975 15.7129 16.0614 15.713 15.0418V1.29959C15.7129 0.82938 15.8685 0.372404 16.1553 3.41272e-05H4.72525C4.08128 -0.00484029 3.55505 0.513066 3.54861 1.15753ZM5.45495 3.0455H9.67143C9.91733 3.0455 10.1166 3.245 10.1166 3.49116C10.1166 3.73731 9.91733 3.93682 9.67143 3.93682H5.45495C5.20905 3.93682 5.00976 3.73731 5.00976 3.49116C5.00976 3.245 5.20905 3.0455 5.45495 3.0455ZM5.45495 6.23197H13.3203C13.5662 6.23197 13.7655 6.43147 13.7655 6.67763C13.7655 6.92378 13.5662 7.12329 13.3203 7.12329H5.45495C5.20905 7.12329 5.00976 6.92378 5.00976 6.67763C5.00976 6.43147 5.20905 6.23197 5.45495 6.23197ZM5.45495 9.41844H13.3203C13.5662 9.41844 13.7655 9.61794 13.7655 9.8641C13.7655 10.1103 13.5662 10.3098 13.3203 10.3098H5.45495C5.20905 10.3098 5.00976 10.1103 5.00976 9.8641C5.00976 9.61794 5.20905 9.41844 5.45495 9.41844Z"
        fill="currentColor"
      />
      <path
        d="M17.9002 3.14852e-05C17.1992 -0.00468088 16.6266 0.559755 16.6201 1.26207V7.44783H19.1803V1.26207C19.1739 0.559755 18.6012 -0.0048554 17.9002 3.14852e-05Z"
        fill="currentColor"
      />
      <circle cx="20.6618" cy="13.3297" r="5.67154" fill="#fff" />
      <circle cx="20.6213" cy="13.3361" r="4.62126" fill="currentColor" />
      <path
        d="M22.3326 13.1705C22.2985 13.0953 22.2237 13.0474 22.1414 13.0474H21.3008V10.3156C21.3008 10.1996 21.2067 10.1055 21.0907 10.1055H20.2501C20.1341 10.1055 20.04 10.1996 20.04 10.3156V13.0474H19.1994C19.117 13.0474 19.0422 13.0957 19.0082 13.1705C18.9737 13.2458 18.9872 13.3336 19.0414 13.3958L20.5124 15.0769C20.5523 15.1227 20.6099 15.1488 20.6704 15.1488C20.7309 15.1488 20.7885 15.1223 20.8284 15.0769L22.2994 13.3958C22.354 13.334 22.3666 13.2458 22.3326 13.1705Z"
        fill="#fff"
      />
      <path
        d="M18.2725 16.0828C18.2725 15.8181 18.487 15.6035 18.7517 15.6035H22.5858C22.8505 15.6035 23.0651 15.8181 23.0651 16.0828C23.0651 16.3475 22.8505 16.562 22.5858 16.562H18.7517C18.487 16.562 18.2725 16.3475 18.2725 16.0828Z"
        fill="#fff"
      />
    </svg>
  );
};

export default InvoiceIcon;
